<template>
  <b-card
    v-if="data"
    no-body
    class="card-statistics"
  >

    <!-- HEADER -->
    <b-card-header class="d-flex justify-content-between">
      <b-card-title class="chart-title mb-0">
        {{ $t('Financial Statistics') }}
      </b-card-title>

      <!-- REFRESH BUTTON -->
      <b-button
        v-if="showRefreshButton"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        size="sm"
        class="widgetrefresh-button d-sm-flex align-items-center justify-content-center shadow-custom"
        :style="cardBorder"
        @click="refreshWidget"
      >
        <feather-icon
          icon="RefreshCwIcon"
          class="mr-50 refresh-icon"
        />
        <time-ago
          class="timeAgo"
          :datetime="lastUpdatedAt"
          refresh
          locale="en"
          :long="true"
          :style="{color: '#1C1F32'}"
        />
      </b-button>
    </b-card-header>

    <!-- BODY -->
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in data"
          :key="item.icon"
          cols="12"
          sm="6"
          md="6"
          lg="6"
          xl="3"
          class="mb-2"
        >
          <b-media
            no-body
            class="financial-stat-card"
            :style="{ backgroundColor: item.bgcolor }"
          >
            <b-media-body class="my-auto">
              <h4
                v-b-tooltip.hover.v-primary
                class="font-weight-bolder stat-number mb-1"
                :title="__numberWithCommas(item.title, true)"
              >
                {{ __numberWithCommas(smartFormatter(item.title)) }}
              </h4>
              <b-card-text class="stat-subtitle font-weight-bolder mb-0 font-small-3">
                {{ $t(item.subtitle) }}
              </b-card-text>
            </b-media-body>

            <b-media-aside class="avatar-container">
              <b-avatar
                class="stat-avatar"
                :style="{ backgroundColor: item.color, color: item.iconColor }"
              >
                <feather-icon
                  :icon="item.icon"
                  size="24"
                />
              </b-avatar>
            </b-media-aside>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>

  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody,
  BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BButton, VBTooltip,
} from 'bootstrap-vue'
import { TimeAgo } from 'vue2-timeago'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
    TimeAgo,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    queue: {
      type: String,
      required: true,
    },
    lastUpdatedAt: {
      type: String,
      default: null,
    },
    showRefreshButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
  methods: {
    refreshWidget() {
      this.$emit('refresh', this.queue)
    },

    // renamed from __numberWithCommas → numberWithCommas
    numberWithCommas(x, isFloat = false) {
      if (Number.isNaN(x)) return x
      const parts = parseFloat(x).toFixed(isFloat ? 2 : 0).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    },

    smartFormatter(value) {
      const abs = Math.abs(value)
      if (abs >= 1.0e9) return `${(value / 1.0e9).toFixed(1)}B`
      if (abs >= 1.0e6) return `${(value / 1.0e6).toFixed(1)}M`
      if (abs >= 1.0e3) return `${(value / 1.0e3).toFixed(1)}K`
      return value.toString()
    },
  },
}
</script>

<style scoped lang="scss">
@import '../@core/scss/vue/pages/widget-refresh.scss';

.financial-stat-card {
  min-height: 110px;
  border-radius: 16px;
  padding: 20px 18px;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}

@media (max-width: 1024px) {
  .financial-stat-card {
    padding: 18px !important;
  }
}

@media (max-width: 768px) {
  .financial-stat-card {
    padding: 16px !important;
  }
}

.stat-number {
  font-size: 22px;
  font-weight: 600;
  color: #1C1F32;
}

.stat-subtitle {
  font-size: 13px !important;
  color: #4B4B4B;
  margin-top: 4px;
}

.avatar-container {
  position: absolute;
  top: 14px;
  right: 14px;
}

.stat-avatar {
  width: 52px !important;
  height: 52px !important;
  border-radius: 50%;
}

.refresh-icon {
  color: #1C1F32;
}
</style>
